import React from "react";
import {Redirect, Route} from 'react-router-dom';
import LoginContainer from './auth/containers/LoginContainer';
import ForgotPasswordContainer from './auth/containers/ForgotPasswordContainer';
import RolesPageContainer from './roles/containers/RolesPageContainer';
import UsersPageContainer from './users/containers/UsersPageContainer';
import EntitiesPageContainer from './entities/containers/EntitiesPageContainer';
import PersonalAreaPageContainer from './personalArea/containers/PersonalAreaPageContainer';
import AuthenticationRoute from "./auth/components/AuthenticationRoute";
import MainLayout from "./shared/components/layout/MainLayout";
import UsersFormContainer from './users/containers/UsersFormContainer';
import RolesFormContainer from './roles/containers/RolesFormContainer';
import EntitiesFormContainer from './entities/containers/EntitiesFormContainer';
import TerminalsPageContainer from "./terminals/containers/TerminalsPageContainer";
import TerminalsFormContainer from "./terminals/containers/TerminalsFormContainer";
import InterfacesFormContainer from "./interfaces/containers/InterfacesFormContainer";
import DashboardPageContainer from './dashboard/containers/DashboardPageContainer';
import RulesPageContainer from "./rules/containers/RulesPageContainer";
import EntityInterfacesFormContainer from "./entityInterfaces/containers/EntityInterfacesFormContainer";
import LoginTokenContainer from "./auth/containers/LoginToken"
import NotFound from './notFound/components/NotFound';
import BillingReportPageContainer from "./billingReport/containers/BillingReportPageContainer";

const routes = [
    <Route
        key='landingPage'
        exact
        path="/"
        component={() => <Redirect to="/auth"/>}
    />,
    <Route
        key='authPage'
        path="/auth"
        component={LoginContainer}
    />,
    <Route
        key='authPage'
        path="/edp-adfs-auth"
        component={() => {
            window.location.href = process.env.REACT_APP_ADFS_LOGIN_URL;
            return <div/>
        }}
    />,
    <Route
        key='authWithTokenFailed'
        path="/authWithTokenFailed"
        component={props => (
            <LoginTokenContainer {...props} />
        )}
    />,
    <Route
        key='authWithToken2'
        path="/authWithToken/:token/:adfsEntity"
        component={props => (
            <LoginTokenContainer {...props} token={props.match.params.token} adfsEntity={props.match.params.adfsEntity}/>
        )}
    />,
    <Route
        key='forgotPasswordPage'
        path="/forgot"
        component={ForgotPasswordContainer}
    />,
    <Route
        key='usersEditPage'
        path={["/users/create", "/users/:userId"]}
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <UsersFormContainer
                        {...props}
                        userId={props.match.params.userId}
                    />
                </MainLayout>
            </AuthenticationRoute>
        )}
    />,
    <Route
        key='usersPage'
        path="/users"
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <UsersPageContainer {...props} />
                </MainLayout>
            </AuthenticationRoute>
        )}
    />,
    <Route
        key='dashboardPage'
        path="/dashboard"
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <DashboardPageContainer {...props} />
                </MainLayout>
            </AuthenticationRoute>
        )}
    />,
    <Route
        key='entityInterfacesEditPage'
        path={["/terminals/:terminalId/interfaces/:interfaceId/entityInterfaces/create", "/entities/:entityId/entityInterfaces/:entityInterfaceId"]}
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <EntityInterfacesFormContainer
                        {...props}
                        interfaceId={props.match.params.interfaceId}
                        entityInterfaceId={props.match.params.entityInterfaceId}
                        entityId={props.match.params.entityId}
                        terminalId={props.match.params.terminalId}
                    />
                </MainLayout>
            </AuthenticationRoute>
        )}
    />,
    <Route
        key='entitiesEditPage'
        path={["/entities/create", "/entities/:entityId"]}
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <EntitiesFormContainer
                        {...props}
                        entityId={props.match.params.entityId}
                    />
                </MainLayout>
            </AuthenticationRoute>
        )}
    />,
    <Route
        key='entitiesPage'
        path="/entities"
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <EntitiesPageContainer {...props} />
                </MainLayout>
            </AuthenticationRoute>
        )}
    />,
    <Route
        key='rolesEditPage'
        path={["/roles/create", "/roles/:roleId"]}
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <RolesFormContainer
                        {...props}
                        roleId={props.match.params.roleId}
                    />
                </MainLayout>
            </AuthenticationRoute>
        )}
    />,
    <Route
        key='rolesPage'
        path="/roles"
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <RolesPageContainer {...props} />
                </MainLayout>
            </AuthenticationRoute>
        )}
    />,
    <Route
    key='billingReportPage'
    path="/billingReport"
    component={props => (
        <AuthenticationRoute>
            <MainLayout {...props} >
              <BillingReportPageContainer {...props}/>
            </MainLayout>
        </AuthenticationRoute>
    )}
/>,
/*     <Route
        key='rulesPage'
        path="/rules"
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <RulesPageContainer {...props} />
                </MainLayout>
            </AuthenticationRoute>
        )}
    />, */
    <Route
        key='personalAreaPage'
        path="/personalArea"
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <PersonalAreaPageContainer {...props} />
                </MainLayout>
            </AuthenticationRoute>
        )}
    />,
    <Route
        key='interfacesEditPage'
        path={["/terminals/:terminalId/interfaces/create", "/terminals/:terminalId/interfaces/:interfaceId"]}
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <InterfacesFormContainer
                        {...props}
                        interfaceId={props.match.params.interfaceId}
                        terminalId={props.match.params.terminalId}
                    />
                </MainLayout>
            </AuthenticationRoute>
        )}
    />,
    <Route
        key='terminalsEditPage'
        path={["/terminals/create", "/terminals/:terminalId"]}
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <TerminalsFormContainer
                        {...props}
                        terminalId={props.match.params.terminalId}
                    />
                </MainLayout>
            </AuthenticationRoute>
        )}
    />,
    <Route
        key='terminalsPage'
        path="/terminals"
        component={props => (
            <AuthenticationRoute>
                <MainLayout {...props} >
                    <TerminalsPageContainer {...props} />
                </MainLayout>
            </AuthenticationRoute>
        )}
    />,
    <Route
    key='notFound'
    component={() => (
        <AuthenticationRoute>
            <NotFound />
        </AuthenticationRoute>
    )}
  />
];

export {
    routes
};
